module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.items), function(item) {
    return _c('v-chip', {
      key: item.id,
      attrs: {
        "small": "",
        "color": item.theme,
        "dark": ""
      },
      on: {
        "click": function($event) {
          return _vm.toggleSelected(item)
        }
      }
    }, [(_vm.facets && item.id in _vm.facets) ? _c('v-avatar', {
      staticClass: "darken-2",
      class: item.theme
    }, [_vm._v(_vm._s(_vm.facets[item.id]))]) : _vm._e(), _vm._v("\n  " + _vm._s(item.title) + "\n  "), (_vm.isSelected(item)) ? _c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": ""
      }
    }, [_vm._v("check")]) : _vm._e()], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-003d4c89","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/StatusPicker.vue
// module id = 1308
// module chunks = 9